import { InProgressIcon, SuccessIcon, WaitingIcon, CancelledIcon } from './components/Index';

export const STEPS_STYLE_NAMES = {
  SUCCESS: 'SUCCESS',
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING: 'WAITING',
  CANCELLED: 'CANCELLED',
  SECONDARY_CANCELLED: 'SECONDARY_CANCELLED'
} as const;

export type TStepStyleName = typeof STEPS_STYLE_NAMES[keyof typeof STEPS_STYLE_NAMES];

interface IStatusStyles {
  titleColor: string;
  icon: React.ReactNode;
  isOpaque: boolean;
}

/**
 * Determina los estilos de los pasos dependiendo del nombre del estilo
 */
export const STEPS_STYLES: Record<TStepStyleName, IStatusStyles> = {
  [STEPS_STYLE_NAMES.SUCCESS]: { titleColor: 'text-nudos-text-color', icon: <SuccessIcon />, isOpaque: false },
  [STEPS_STYLE_NAMES.IN_PROGRESS]: { titleColor: 'text-nudos-text-color', icon: <InProgressIcon />, isOpaque: false },
  [STEPS_STYLE_NAMES.WAITING]: { titleColor: 'text-nudos-gray-500', icon: <WaitingIcon />, isOpaque: false },
  [STEPS_STYLE_NAMES.CANCELLED]: { titleColor: 'text-nudos-red-100', icon: <CancelledIcon />, isOpaque: false },
  [STEPS_STYLE_NAMES.SECONDARY_CANCELLED]: {
    titleColor: 'text-nudos-gray-500',
    icon: <CancelledIcon isSecondaryCancelled />,
    isOpaque: true
  }
};
